<template>
  <div class="map_app">
    <div class="my-3">
      <div class="mb-3">
        <label class="form-label">
          <b>{{ selectLabel }}</b>
        </label>
        <vue-multiselect
            @select="FlyTo(selected)"
            v-model="selected"
            :options="options"
            :allow-empty="false"
            :clear-on-select="false"
            placeholder="Seleziona"
            selectLabel="Clicca per selezionare"
            deselectLabel="Clicca per deselezionare"
            selectedLabel="Selezionato"
            label="label"
            track-by="value"
        />
      </div>

    </div>
    <div class="map_wrapper">
      <l-map ref="map" :zoom="zoom" :center="center" id="map">
        <l-tile-layer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            layer-type="base"
            name="OpenStreetMap"
        ></l-tile-layer>
        <div v-for="(i, index) in items" :key="index">
          <l-marker :lat-lng="i.latlng">
            <l-icon :icon-url="iconUrl" :icon-size="iconSize" :icon-anchor="iconAnchor"></l-icon>
            <l-popup>
              <div class="title">
                <h3>{{ i.name }}</h3>
              </div>
              <div class="divider top"></div>
              <div class="image" :style="{ 'background-image': 'url(' + i.image +')'}"></div>
              <div class="divider"></div>
              <div class="address">
                {{ i.address }}
              </div>
              <a :href="i.website" target="_blank">
                Scopri la programmazione
              </a>
            </l-popup>
          </l-marker>
        </div>
      </l-map>
    </div>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import "leaflet/dist/leaflet.css";
import {LMap, LMarker, LPopup, LIcon, LTileLayer} from "@vue-leaflet/vue-leaflet";
import {computed, onMounted, onUnmounted, ref} from "vue";
import icon from "../assets/pin.png";
import data from "../../data/theaters.json";

export default {
  name: "CinemaMap",
  components: {
    VueMultiselect,
    LMap,
    LTileLayer,
    LPopup,
    LIcon,
    LMarker
  },
  setup() {
    const useBreakpoints = () => {

      let windowWidth = ref(window.innerWidth)

      const onWidthChange = () => windowWidth.value = window.innerWidth
      onMounted(() => window.addEventListener('resize', onWidthChange))
      onUnmounted(() => window.removeEventListener('resize', onWidthChange))

      const type = computed(() => {
        if (windowWidth.value < 550) return 'xs'
        if (windowWidth.value >= 550 && windowWidth.value < 1200) return 'md'
        if (windowWidth.value >= 1200) return 'lg'
        return null; // This is an unreachable line, simply to keep eslint happy.
      })

      const width = computed(() => windowWidth.value)

      return {width, type}
    }

    let {width, type} = useBreakpoints()

    let items = ref(
        data.theaters
    )

    const selectLabel = ref('Scegli la provincia')

    const map = ref(null);

    const center = ref(
        [45.13518514090894, 7.944973492940374]
    )

    const zoom = computed(() => {
      if (type.value === 'lg') {
        return 8
      } else if (type.value === 'md') {
        return 7
      } else {
        return 6
      }
    })

    const selected = ref(
        {
          value: 'tutte',
          label: 'Tutte',
          center: center.value,
          zoom: zoom.value
        }
    )

    const zoomTorino = computed(() => {
      if (type.value === 'lg') {
        return 9
      } else if (type.value === 'md') {
        return 8
      } else {
        return 7
      }
    })

    const zoomVercelli = computed(() => {
      if (type.value === 'lg') {
        return 10
      } else if (type.value === 'md') {
        return 9
      } else {
        return 8
      }
    })

    const zoomCuneo = computed(() => {
      if (type.value === 'lg') {
        return 10
      } else if (type.value === 'md') {
        return 9
      } else {
        return 8
      }
    })

    let iconWidth = ref(
        28
    )

    const iconHeight = ref(
        38
    )

    const FlyTo = (i) => {
      map.value.leafletObject.flyTo(i.center, i.zoom);
      console.log(i.center, i.zoom)
    }

    const iconUrl = computed(() => icon)
    const iconSize = computed(() => [iconWidth.value, iconHeight.value])
    const iconAnchor = computed(() => [(iconWidth.value) / 2, iconHeight.value])


    const options = ref(
        [
          {
            value: 'tutte',
            label: 'Tutte',
            center: center.value,
            zoom: zoom.value,
          },
          {
            value: 'alessandria',
            label: 'Alessandria',
            center: [44.76027341067297, 8.785910330818442],
            zoom: 14
          },
          {
            value: 'asti',
            label: 'Asti',
            center: [44.910278903390925, 8.198224350939553],
            zoom: 14
          },
          {
            value: 'biella',
            label: 'Biella',
            center: [45.54707831242489, 8.112423929956528],
            zoom: 14
          },
          {
            value: 'cuneo',
            label: 'Cuneo',
            center: [44.52548515855983, 7.578771315466782],
            zoom: zoomCuneo.value
          },
          {
            value: 'novara',
            label: 'Novara',
            center: [45.47647910215972, 8.679593080777405],
            zoom: 12
          },
          {
            value: 'torino',
            label: 'Torino',
            center: [45.0677551, 7.6824892],
            zoom: zoomTorino.value
          },
          {
            value: 'verbano_cusio_ossola',
            label: 'Verbano-Cusio-Ossola',
            center: [46.133623224294986, 8.293369616928759],
            zoom: 14
          },
          {
            value: 'vercelli',
            label: 'Vercelli',
            center: [45.57513389852011, 8.330814647395812],
            zoom: zoomVercelli.value
          }
        ]
    );


    return {
      map,
      options,
      items,
      selected,
      zoom,
      center,
      iconWidth,
      iconHeight,
      iconUrl,
      FlyTo,
      iconSize,
      iconAnchor,
      width,
      type,
      zoomTorino,
      selectLabel
    }
  }
};
</script>

<style lang="scss">


.map_wrapper {
  width: 100%;
  height: 70vh;
}

.leaflet-container {
  z-index: 10;
}

.leaflet-popup-content {
  max-width: 200px;
}

.multiselect__content-wrapper {
  z-index: 100;
  max-height: 500px !important;
}

.image {
  background-size: contain;
  background-position: center, center;
  background-repeat: no-repeat;
  width: 200px;
  height: 130px;
}

.telephone,
.address {
  margin: 6px 0;
  font-size: 1em;
  color: #1d1d1d;
  font-family: 'Lato', sans-serif;
  text-decoration: none;
}

.title h3 {
  font-size: 1.25em !important;
  font-family: 'Nunito', sans-serif;
  font-weight: 700;
  text-decoration: none;
  color: #E0003FFF;
}

.leaflet-popup-content a {
  font-family: 'Nunito', sans-serif;
  font-weight: 800;
  color: #103b6d;
}

.divider {
  border-top: 1px solid rgba(245, 162, 0, 1);
  margin-top: .5em;
}

.divider.top {
  margin-bottom: .5em;
}

</style>
